<template>
    <div class="custom-form-group" :class="[formGroupClass, {'is-invalid': getError(name)}]">
        <label class="form-label" :for="uniqid" v-if="label">{{ label }}</label>
        <textarea
            :id="uniqid"
            :name="name"
            :placeholder="placeholder"
            class="form-control"
            :class="{'is-invalid': getError(name)}"
            :style="{height: height}"
            :value="value"
            :disabled="disabled"
            @keyup="updateValue($event.target.value)"
            @change="updateValue($event.target.value)"
            :aria-describedby="uniqid+'-addon '+uniqid+'-feedback'"
        />
        <div class="custom-info" v-if="customInfo"> {{ customInfo }}</div>
        <div class="invalid-feedback" :id="uniqid+'-feedback'">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
import uniqid from 'uniqid'

export default {

    props: {
        value: {
            required: true
        },
        disabled: {
            default: false
        },
        name: {
            required: true
        },
        label: {
            default: false
        },
        placeholder: {
            default: ''
        },
        customInfo: {
            default: false
        },
        formGroupClass: {
            default: null
        },
        customErrorMessage: {
            default: null
        },
        height: {
            default: 'auto'
        }
    },

    inject: [
        'getError',
        'clearError'
    ],

    data () {
        return {
            uniqid: uniqid()
        }
    },

    computed: {
        errorMessage () {
            if (this.getError(this.name) && Array.isArray(this.getError(this.name))) {
                if (this.customErrorMessage) {
                    return this.customErrorMessage
                } else {
                    return this.getError(this.name)[0]
                }
            }
            return ''
        }
    },

    methods: {
        updateValue (value) {
            this.$emit('input', value)
            this.clearError(this.name)
        }
    }

}
</script>
